import { UserDetailsContext } from "App";
import Select from "common-ui-components/components/select";
import React, { useContext, useEffect } from "react";
import CustomerImg from "./icons/customer.svg";
import styles from "./Customer.module.css";
import { ALL_CUSTOMER_ID } from "utils/mspConstants";

// 0 - no customerId change occurs but in ui alone All Customers will be set in disable
// 1 - all customer option selected disabled
// 2 - customer specific options and first cutomer will be selected if no customer ID
// 3 - both all customer and customer specific options and selected cutomer or all customer
// -1 - abrupt dropdown disable

//   customers = [
//     { "2": "Customer 2" },
//     { "3": "Customer 3" },
//     { "4": "Customer 4" },
//     { "5": "Customer 5" },
//   ];

const Dropdown = ({ mode }) => {
  const userDetails = useContext(UserDetailsContext);
  const customers = userDetails?.customers || [];
  const currentCustomerId = userDetails?.currentCustomerId;
  const isAllCustomerNeeded = userDetails?.isAllCustomerNeeded;

  const setCurrentCustomerId = (customerId) => {
    const forcedId = localStorage.getItem("forcedCustomerId");

    let id = customerId;

    if (forcedId && forcedId !== "0") 
    {
      id = forcedId; //getting the forcedCustomerId for setting a new customer id which was forced rather than auto setting
      localStorage.removeItem("forcedCustomerId");
    }

    if (userDetails.currentCustomerId !== id) 
    {
      userDetails.setUserDetails((prev) => ({
        ...prev, //setting in userDetails app context for immediate re rendering
        currentCustomerId: id,
      }));
    }
  };

  const customerIds = customers.map((item) => Number(Object.keys(item)[0]));
  const customerList = customers.map((item) => Object.values(item)[0]);

  const modifiedCustomerIds = [...customerIds];
  const modifiedCustomerList = [...customerList];

  if (isAllCustomerNeeded && mode === 2) 
  {
    modifiedCustomerList.pop();
    modifiedCustomerIds.pop();
  }

  useEffect(() => {
    if (isAllCustomerNeeded && mode === 2) 
    {
      //auto setting to first id if previous id was all customer and currenctly moving into a specific customer
      if (Number(currentCustomerId) === ALL_CUSTOMER_ID)
        setCurrentCustomerId(customerIds[0]);
    }
    else if (isAllCustomerNeeded && mode === 1) 
    {
      //auto setting if previous id a non all-customer and currenctly moving into a all customer mode only
      if (Number(currentCustomerId) !== ALL_CUSTOMER_ID)
        setCurrentCustomerId(ALL_CUSTOMER_ID);
    }
  }, [isAllCustomerNeeded, mode, currentCustomerId, customerIds]);

  const activeCustomerIndex = modifiedCustomerIds.findIndex(
    (id) => id === Number(currentCustomerId),
  );

  const getCustomerIdfromName = (customerName) => {
    const item = customers.find(
      (obj) => Object.values(obj)[0] === customerName,
    );
    return item ? Object.keys(item)[0] : null;
  };

  const CustomerListOptions = () => {
    let toDisable = false;
    let activeIndex = activeCustomerIndex >= 0 ? activeCustomerIndex : 0;

    if (mode === 0) {
      activeIndex = modifiedCustomerList.length - 1;
      toDisable = true;
    }

    if (mode === 1 && isAllCustomerNeeded) {
      activeIndex = modifiedCustomerList.length - 1;
      toDisable = true;
    }

    if (mode === -1) 
      toDisable = true;

    const CustomerImge = () => {
      return (
        <img src={CustomerImg} style={{ width: "20px", height: "20px" }} />
      );
    };

    return (
      <div
        style={
          toDisable
            ? {
                pointerEvents: "none",
                opacity: 0.5,
              }
            : null
        }
        className={styles.customerDropdown}
      >
        {modifiedCustomerList.length > 0 && (
          <Select
            options={modifiedCustomerList}
            active={activeIndex}
            onOptionSelect={(option) =>
              setCurrentCustomerId(getCustomerIdfromName(option))
            }
            containerProps={{
              style: {
                maxWidth: "15.5rem",
                minWidth: 0,
              },
            }}
            triggerProps={{
              toolTipText: modifiedCustomerList[activeIndex],
              style: {
                minWidth: 0,
                width: "100%",
                overflow: "hidden",
              },
              triggerTextStyle: {
                flex: 1,
                minWidth: 0,
                width: "auto",
              },
              arrowContainerStyle: {
                alignSelf: "center",
                flex: "0 0 auto",
              },
            }}
            childrenProps={{
              className: styles.customerOptions,
              style: {
                zIndex: 900,
              },
            }}
            ExtraComponent={CustomerImge}
          />
        )}
      </div>
    );
  };

  return <CustomerListOptions />;
};

export default Dropdown;
